const AUDIO_FEATURES = [
    {
        title: "Best Danceability",
        feature: "danceability",
    },
    {
        title: "Highest Energy",
        feature: "energy",
    },
    {
        title: "Fastest Tempo",
        feature: "tempo",
    },
    {
        title: "Loudest Tracks",
        feature: "loudness",
    },
    {
        title: "Most Upbeat",
        feature: "valence",
    },
    {
        title: "Highest Speechiness",
        feature: "speechiness",
    }
];

export default AUDIO_FEATURES;